import React from "react";
import { ButtonIconRenderProps, ButtonProps } from "../../button";
import { StyledActionButton } from "../styled/ActionButton";

export interface ModalActionButtonProps extends Omit<ButtonProps, "content"> {
    /**
     * the aria-label attribute associated with the button.
     */
    "aria-label": string;
    /**
     * function to be called on click
     */
    onClick: () => void;
    /**
     * content to be rendered
     */
    content?: React.ReactChild | ButtonIconRenderProps;
}

export const ModalActionButton = React.forwardRef<HTMLButtonElement, ModalActionButtonProps>(
    ({ content, onClick, "aria-label": ariaLabel, ...props }, ref) => {
        return (
            <StyledActionButton
                onClick={onClick}
                appearance="borderless"
                type="button"
                aria-label={ariaLabel}
                ref={ref}
                {...props}
            >
                {content}
            </StyledActionButton>
        );
    }
);

ModalActionButton.displayName = "ModalActionButton";
